import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { UserSettings } from '../../../shared/types';

interface SettingsStore extends UserSettings {
  // Actions
  setTheme: (theme: UserSettings['theme']) => void;
  setLanguage: (language: UserSettings['language']) => void;
  setSoundEnabled: (enabled: boolean) => void;
  setHapticEnabled: (enabled: boolean) => void;
  setHighlightSimilar: (enabled: boolean) => void;
  setShowTimer: (enabled: boolean) => void;
  setAutoCheckErrors: (enabled: boolean) => void;
  reset: () => void;
}

const DEFAULT_SETTINGS: UserSettings = {
  theme: 'auto',
  language: 'en',
  soundEnabled: true,
  hapticEnabled: true,
  highlightSimilar: true,
  showTimer: true,
  autoCheckErrors: false,
};

export const useSettingsStore = create<SettingsStore>()(
  persist(
    (set) => ({
      // Initial state
      ...DEFAULT_SETTINGS,

      // Actions
      setTheme: (theme) => set({ theme }),
      setLanguage: (language) => set({ language }),
      setSoundEnabled: (soundEnabled) => set({ soundEnabled }),
      setHapticEnabled: (hapticEnabled) => set({ hapticEnabled }),
      setHighlightSimilar: (highlightSimilar) => set({ highlightSimilar }),
      setShowTimer: (showTimer) => set({ showTimer }),
      setAutoCheckErrors: (autoCheckErrors) => set({ autoCheckErrors }),
      reset: () => set(DEFAULT_SETTINGS),
    }),
    {
      name: 'sudoku-settings-storage',
    }
  )
);


